import React from "react";

const Main = () => {
  return (
    <div>
      <h1>welcom</h1>
    </div>
  );
};

export default Main;
